import Swiper from "swiper";
import { Navigation, Keyboard, Autoplay } from "swiper/modules";
import customSelect from "../modules/select";
import '../modules/consultationForm';
import {setAdBannersforMobOrDesk} from '../modules/banners';
import {showHiddenContentOnMob} from '../modules/aside';

function headingSearchMBA() {
    const findBtnObj = {
        base: "mba",
        subject: "",
        country: "",
    };

    document
        .querySelector('#nationality[data-plugin="choises"]')
        .addEventListener("addItem", function (e) {
            findBtnObj.subject = e.detail.value.trim() || "";
        });

    document
        .querySelector('#mba_country[data-plugin="choises"]')
        .addEventListener("addItem", function (e) {
            findBtnObj.country = e.detail.value.trim() || "";
        });

    document
        .querySelector('[data-btn="find-mba"]')
        .addEventListener("click", function (e) {
            e.preventDefault();

            const mbaURL =
                "/" +
                [findBtnObj.base, findBtnObj.subject, findBtnObj.country]
                    .filter(Boolean)
                    .join("/");
            location.href = mbaURL;
        });
}

function toolsSlider(selector) {
    const toolsContainer = document.querySelector(selector);

    if (toolsContainer) {
        const toolsConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            initialSlide: toolsContainer.dataset.initialSlide,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: ".tools .unm-slider-btn-next",
                prevEl: ".tools .unm-slider-btn-prev",
            },
        };

        const toolsSwiper = new Swiper(`${selector} .swiper`, toolsConfig);

        return toolsSwiper;
    }
}

function studentExpSlider() {
    const trendingContainer = document.querySelector(
        '[data-module="student-exp-slider"]'
    );

    if (trendingContainer) {
        const trendingConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                // when window width is >= 480px
                650: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                },
            },
            navigation: {
                nextEl: '[data-module="student-exp-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="student-exp-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const trendingSwiper = new Swiper(
            '[data-module="student-exp-slider"] .swiper',
            trendingConfig
        );
        return trendingSwiper;
    }
}

function trendingSlider() {
    const trendingContainer = document.querySelector('[data-module="trending-slider"]');

    if (trendingContainer) {
        const trendingConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            breakpoints: {
                // when window width is >= 480px
                650: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                },
            },
            navigation: {
                nextEl: '[data-module="trending-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="trending-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const trendingSwiper = new Swiper(
            '[data-module="trending-slider"] .swiper',
            trendingConfig
        );
        return trendingSwiper;
    }
}

function orientationSlider() {
    const trendingContainer = document.querySelector(
        '[data-module="orientation-slider"]'
    );

    if (trendingContainer) {
        const trendingConfig = {
            modules: [Navigation, Keyboard, Autoplay],
            // direction: 'vertical',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            breakpoints: {
                // when window width is >= 480px
                650: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
            },
            navigation: {
                nextEl: '[data-module="orientation-slider"] .unm-slider-btn-next',
                prevEl: '[data-module="orientation-slider"] .unm-slider-btn-prev',
            },
            watchOverflow: true,
        };

        const trendingSwiper = new Swiper(
            '[data-module="orientation-slider"] .swiper',
            trendingConfig
        );
        return trendingSwiper;
    }
}
document.addEventListener("DOMContentLoaded", () => {
    const matchingToolSlider = toolsSlider('[data-module="tools-slider"][data-tab="starting"]');
    studentExpSlider();
    trendingSlider();
    orientationSlider();
    customSelect({ removeItemButton: true });
    headingSearchMBA();
    showHiddenContentOnMob();
    setAdBannersforMobOrDesk();

    document.querySelectorAll(".journey .sec-heading [data-ad-tab]").forEach((tab) => {

            let toolSlider;

            tab.addEventListener("click", function (e) {
                if (matchingToolSlider) {
                    matchingToolSlider.destroy(true, true);
                }

                if (toolSlider) {
                    toolSlider.destroy(true, true);
                }

                toolSlider = toolsSlider(`[data-ad-content="${tab.dataset.adTarget}"] [data-module="tools-slider"]`);
            });
        });
});
